var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 302,
    viewBox: "0 0 180 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.864 163.9C118.264 157 104.764 151.9 91.8641 146.8C71.1641 138.7 51.9641 130.9 37.5641 118C22.8641 105.1 16.8641 90.1 19.8641 74.5C22.8641 56.2 38.4641 40.3 61.8641 31C97.5641 17.2 140.764 25.6 167.464 53.2L178.864 42.1C148.264 10.6 96.9641 0.699983 55.8641 16.3C27.9641 26.8 8.46406 47.8 3.96406 71.5C0.364063 92.5 8.76406 113.5 26.7641 129.7C43.5641 145 65.1641 153.4 85.8641 161.5C98.4641 166.3 111.664 171.4 123.064 178C142.564 189.1 155.764 204.4 159.964 220.6C163.264 232.3 161.764 242.8 155.464 253.3C145.864 270.4 127.264 281.2 102.364 284.5C69.6641 289 35.1641 278.8 13.8641 257.8L2.46406 268.9C23.7641 290.2 55.5641 301.6 87.3641 301.6C93.0641 301.6 98.7641 301 104.164 300.4C133.564 296.5 157.264 282.4 169.564 261.4C177.664 247.3 179.464 231.4 175.564 216.4C170.164 196.3 153.364 176.8 130.864 163.9Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperS);
export default __webpack_public_path__ + "static/media/UPPER_S.76b53b27e783458856fc7c4fc64334be.svg";
export { ForwardRef as ReactComponent };